export const ArrowLeftIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Arrow Left",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    {...rest}>
    <title>{title}</title>
    <path
      fill="currentColor"
      stroke="currentColor"
      d="M10.66 5.64a.5.5 0 0 0-.707.012l-5.812 6a.5.5 0 0 0 0 .696l5.812 6a.5.5 0 0 0 .719-.696L5.68 12.5H19.5a.5.5 0 0 0 0-1H5.68l4.992-5.153a.501.501 0 0 0-.012-.707Z"
    />
  </svg>
);
